import httpClient from "../httpClient";
import { API_MEMBER_LOGIN } from "../config";

const loginService = {
  memberLoginInfo: (data) => httpClient.post(API_MEMBER_LOGIN, data),
};

export default loginService;
